import { css } from '@utils/css';

const anchor = css`
  text-decoration: none;
  color: currentColor;
`;

export { anchor };
//# sourceMappingURL=anchor.js.map
